import React from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
} from "react-bootstrap";
import Select from "react-select";
// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { Query, useMutation } from "react-apollo";
import { GET_CLIENT } from "./queries";

import map from "lodash/map";
import withSession from "./withSession";
import {
  ADD_VISUALIZATION_TO_CLIENT,
  UPDATE_VISUALIZATION,
  DELETE_VISUALIZATION,
} from "./mutations";

function VisualizationManager(props) {
  const [modal, setModal] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [modalPassword, setModalPassword] = React.useState(false);

  const [title, setTitle] = React.useState("");
  const [age, setAge] = React.useState("");
  const [description, setVisualizationDescription] = React.useState("");
  const [audioLink, setAudioLink] = React.useState("");
  const [showError, setShowError] = React.useState("");
  const [showErrorConfirm, setShowErrorConfirm] = React.useState("");

  const [editVisualizationId, seteditVisualizationId] = React.useState("");
  const [deleteVisualizationId, setDeleteVisualizationId] = React.useState("");

  const [addVisualizationToClient] = useMutation(ADD_VISUALIZATION_TO_CLIENT);
  const [updateVisualization] = useMutation(UPDATE_VISUALIZATION);
  const [deleteVisualization] = useMutation(DELETE_VISUALIZATION);

  const handleClose = () => {
    setModal(false);
    setTitle("");
    setAge("");
    setVisualizationDescription("");
    setAudioLink("");
    seteditVisualizationId("");
  };

  const handleOpenDelete = (visualization) => {
    setDeleteModal(true);
    setDeleteVisualizationId(visualization._id);
  };

  const handleCloseDelete = (user) => {
    setDeleteModal(false);
    setDeleteVisualizationId("");
  };

  const handleAddVisualization = () => {
    let visualization = {
      title,
      age,
      description,
      audioLink,
    };

    addVisualizationToClient({
      variables: {
        name: props.session.me.clientName,
        visualization,
      },
      refetchQueries: [
        {
          query: GET_CLIENT,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleOpenEdit = (visualization) => {
    setModal(true);
    setTitle(visualization.title);
    setAge(visualization.age);
    setVisualizationDescription(visualization.description);
    setAudioLink(visualization.audioLink);
    seteditVisualizationId(visualization._id);
    setShowError("");
  };

  const handleEditVisualization = async (editVisualizationId) => {
    const visualizationUpdate = {
      title,
      age,
      description,
      audioLink,
    };
    try {
      await updateVisualization({
        variables: {
          visualizationId: editVisualizationId,
          name: props.session.me.clientName,
          visualizationUpdate,
        },
      })
        .then(() => {
          handleClose();
        })
        .catch((error) => {
          setShowError(error.message);
        });
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating visualization:", error);
    }
  };

  const handleDeleteVisualization = async (deleteVisualizationId) => {
    try {
      await deleteVisualization({
        variables: {
          visualizationId: deleteVisualizationId,
          name: props.session.me.clientName,
        },
      })
        .then(() => {
          handleCloseDelete();
        })
        .catch((error) => {
          setShowError(error.message);
        });
      // Handle successful update, e.g., showing a success message or redirecting
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating visualization:", error);
    }
  };

  const ageOptions = [
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "Adult", label: "Adult" },
  ];

  return (
    <Query
      query={GET_CLIENT}
      variables={{
        name: props.session.me.clientName,
      }}
    >
      {({ loading, data, refetch }) => {
        if (loading) return "Loading...";
        const { getClient } = data;
        const { visualizations, adminUsers = [] } = getClient || {};

        const tableData = map(visualizations, (visualization, key) => {
          return {
            id: key,
            ...visualization,
          };
        });
        return (
          <>
            <Container fluid>
              <Row>
                <Col md="12">
                  <h4 className="title">Visualization Manager</h4>
                  {/* <p className="category">
                          A powerful react plugin handcrafted by our friends from{" "}
                          <a
                            href="https://react-table.tanstack.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            react-table
                          </a>
                          . It is a highly flexible tool, based upon the foundations of
                          progressive enhancement on which you can add advanced interaction
                          controls. Please check out their{" "}
                          <a
                            href="https://react-table.tanstack.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            full documentation.
                          </a>
                        </p> */}
                  <Card>
                    <Card.Body>
                      <ReactTable
                        data={tableData}
                        columns={[
                          {
                            header: "Title",
                            accessorKey: "title",
                          },
                          {
                            header: "Age",
                            accessorKey: "age",
                            cell: ({ getValue }) =>
                              getValue() ? getValue().join(", ") : "",
                          },
                          {
                            header: "Description",
                            accessorKey: "description",
                          },
                          {
                            header: "Audio Link",
                            accessorKey: "audioLink",
                          },
                          {
                            header: "Actions",
                            accessorKey: "actions",
                            enableSorting: false,
                            enableColumnFilter: false,
                            cell: ({ row }) => {
                              const visualization = row.original;
                              return (
                                // we've added some custom button actions
                                <div className="actions-right">
                                  {/* use this button to add a edit kind of action */}
                                  <Button
                                    variant="warning"
                                    size="sm"
                                    className="text-warning btn-link edit"
                                    onClick={() =>
                                      handleOpenEdit(visualization)
                                    }
                                  >
                                    <i className="fa fa-edit" />
                                  </Button>{" "}
                                  <Button
                                    variant="danger"
                                    size="sm"
                                    className="text-danger btn-link edit"
                                    onClick={() =>
                                      handleOpenDelete(visualization)
                                    }
                                  >
                                    <i className="fa fa-trash" />
                                  </Button>{" "}
                                </div>
                              );
                            },
                          },
                        ]}
                        /*
                                You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                              */
                        className="-striped -highlight primary-pagination"
                      />
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs="12" style={{ marginTop: 25, textAlign: "right" }}>
                  <Button
                    onClick={() => setModal(!modal)}
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    Add Visualization
                  </Button>
                </Col>
              </Row>
            </Container>
            <Modal
              className="modal-primary"
              onHide={handleClose}
              show={modal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>
                  {editVisualizationId ? "Edit" : "Add"} Visualization
                </label>
              </Modal.Header>
              <Modal.Body>
                <Form action="#" method="#">
                  <Form.Group>
                    <label>Title</label>
                    <Form.Control
                      value={title}
                      placeholder="Title"
                      type="string"
                      onChange={(event) => setTitle(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Age</label>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      placeholder="Choose Ages"
                      name="multipleAgeSelect"
                      closeMenuOnSelect={false}
                      isMulti
                      value={(age || []).map((a) => {
                        const matchingOption = ageOptions.find(
                          (option) =>
                            option.value === a || option.value === a.value
                        );
                        return (
                          matchingOption || { value: a, label: a.label || a }
                        );
                      })}
                      onChange={(selectedOptions) => {
                        // If selectedOptions is null or undefined, default to an empty array
                        const agesValues = (selectedOptions || []).map(
                          (option) => {
                            return typeof option === "object"
                              ? option.value
                              : option;
                          }
                        );

                        setAge(agesValues);
                      }}
                      options={ageOptions} // Use the options array here
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Description</label>
                    <Form.Control
                      value={description}
                      placeholder="Description"
                      type="string"
                      onChange={(event) =>
                        setVisualizationDescription(event.target.value)
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Audio Link</label>
                    <Form.Control
                      value={audioLink}
                      placeholder="Audio Link"
                      type="string"
                      onChange={(event) => setAudioLink(event.target.value)}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleClose}
                  variant="link"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={
                    editVisualizationId
                      ? () => handleEditVisualization(editVisualizationId)
                      : handleAddVisualization
                  }
                  variant="outlined"
                  color="primary"
                  disabled={!title || !age || !description || !audioLink}
                >
                  Save
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleCloseDelete}
              show={deleteModal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Delete Visualization</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this Visualization? This action
                cannot be undone
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleCloseDelete}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={() =>
                    handleDeleteVisualization(deleteVisualizationId)
                  }
                  variant="danger"
                  color="primary"
                >
                  Delete Visualization
                </Button>
              </div>
            </Modal>
          </>
        );
      }}
    </Query>
  );
}

export default withSession(VisualizationManager);
